var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counpon-page"},[_c('mt-field',{staticClass:"required",attrs:{"label":"串码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_c('mt-button',{staticClass:"user-btn",staticStyle:{"margin":"30px 0"},attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("提交串码")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }